import HomeIcon from "@mui/icons-material/Home";
import MarkunreadMailboxIcon from "@mui/icons-material/MarkunreadMailbox";
import { useEffect, useState } from "react";

import L from "leaflet";

import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
const Location = ({ data }) => {
  const [position, setPostion] = useState(false);
  useEffect(() => {
    var temp = [];
    if (data?.lat) {
      temp.push(Number(data?.lat));
      temp.push(Number(data?.lon));
    }
    setPostion(temp);
  }, [data?.lat]);
  const iconPerson = new L.Icon({
    iconUrl: "/images/map-marker (1).svg",
    iconRetinaUrl: "/images/map-marker (1).svg",

    iconSize: new L.Point(60, 75),
    className: "leaflet-div-icon",
  });
  console.log(position , 'positionposition')
  return (
    <div className="bg-white rounded-md py-3 mt-5 md:mt-0 md:px-10 px-4 flex flex-col gap-3">
      <span className="text-sm font-bold">Location</span>
      <div className="grid grid-cols-2">
        <div className="flex items-center gap-3">
          <MarkunreadMailboxIcon sx={{ fontSize: "15px", color: "#4D4D4D" }} />
          <span className="text-sm text-[#4D4D4D]">PO box : </span>
        </div>
        <h3 className="text-[#4D4D4D] text-sm font-bold">{data?.postalCode}</h3>
      </div>{" "}
      <div className="grid grid-cols-2">
        <div className="flex items-center gap-3">
          <HomeIcon sx={{ fontSize: "15px", color: "#4D4D4D" }} />
          <span className="text-sm text-[#4D4D4D]">Address : </span>
        </div>
        <h3 className="text-[#4D4D4D] text-sm font-bold">
          {data?.country} , {data?.province} , {data?.city}{" "}
          {data?.region ? <> ,{data?.region}</> : <></>}{" "}
        </h3>
      </div>
      {position && position?.length === 2 && (
        <div className="MapMainCom">
          <MapContainer center={position} zoom={13} scrollWheelZoom={false}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker icon={iconPerson} position={position}>
              <Popup>
                A pretty CSS3 popup. <br /> Easily customizable.
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      )}
    </div>
  );
};

export default Location;
